import { render, staticRenderFns } from "./RestaurantSelector.vue?vue&type=template&id=6600a5ae"
import script from "./RestaurantSelector.vue?vue&type=script&lang=ts"
export * from "./RestaurantSelector.vue?vue&type=script&lang=ts"
import style0 from "./RestaurantSelector.vue?vue&type=style&index=0&id=6600a5ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports